import styled from 'styled-components';
import { Radio as SemanticRadio } from 'semantic-ui-react';
import { theme } from '../../styles/theme';

const Radio = styled(SemanticRadio)`
  &&& {
    min-width: 12px;
    min-height: 12px;
    line-height: 12px;

    input:focus ~ label,
    input:active ~ label {
      color: ${theme.colors.secondary800};
    }

    label {
      padding-left: 20px;
      font-size: 12px;
      font-weight: 500;
      color: ${theme.colors.secondary800};
    }

    label::before,
    label::after {
      top: 0;
      width: 12px;
      height: 12px;
    }

    label::before {
      border-color: ${theme.colors.secondary800};
    }

    label::after {
      background-color: ${theme.colors.secondary800};
    }

    input:checked ~ label {
      color: ${theme.colors.mainBlue};
    }

    input:checked ~ label::before {
      border-color: ${theme.colors.mainBlue};
    }

    input:focus:checked ~ label::after,
    input:checked ~ label::after {
      background-color: ${theme.colors.mainBlue};
    }

    input[disabled] ~ label {
      opacity: 1;
      color: ${theme.colors.secondary400};
    }
    input[disabled] ~ label::before {
      background-color: ${theme.colors.secondary600};
    }
  }
`;

export default Radio;
